module.exports = __webpack_public_path__ + "static/img/doctor.5790b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/doctor.png
// module id = g3Hb
// module chunks = 7